import React from 'react';
import { Card } from 'semantic-ui-react';
import MessageTemplatesTable from '../../components/MessageTemplatesTable';

const MessageTemplate = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>消息模板</Card.Header>
          <p style={{ color: '#8a919f', marginTop: 0 }}>
            template_key → 平台模板映射：公众号模板消息（微信模板 ID）与短信（阿里云
            TemplateCode，签名统一使用网关自己的签名）。模板全局通用、所有接入系统共用一套映射，
            因此 template_key 命名需跨系统统一；某系统要不同文案，请使用不同的 template_key。
          </p>
          <MessageTemplatesTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default MessageTemplate;
